module.exports = __webpack_public_path__ + "static/media/motoLogo.e33c790a.png";